import type { MaskedTextBoxChangeEvent } from "@tql/ui-components-react/kendo/inputs";
import { Error, Label } from "@tql/ui-components-react/kendo/labels";
import {
	MaskedTextBox,
	TextBox,
} from "@tql/ui-components-react/tql/inputs/beta";
import { useContext } from "react";

import { QuoteDetailsContext } from "~/features/quote/context/quote-details-context.tsx";

type EmergencyContactSectionProps = Readonly<{
	hasFieldError?: (fieldName: string) => boolean;
	onClearFieldError?: (fieldName: string) => void;
	isRequired?: boolean;
}>;

export function EmergencyContactSection({
	hasFieldError,
	onClearFieldError,
	isRequired = true,
}: EmergencyContactSectionProps) {
	const { quoteState, onChange } = useContext(QuoteDetailsContext);
	const nameError = hasFieldError?.("emergencyContactName") ?? false;
	const phoneError = hasFieldError?.("emergencyContactPhone") ?? false;

	return (
		<div className={"additional-details-row"}>
			<div className={"additional-details-value"}>
				<Label editorId={"emergencyContactName"}>
					Emergency Contact Name{" "}
					{isRequired ? <span className={"required"}>&nbsp;*</span> : null}
				</Label>
				<TextBox
					id={"emergencyContactName"}
					name={"emergencyContactName"}
					onChange={(e) => {
						onClearFieldError?.("emergencyContactName");
						onChange("emergencyContactName", e.value as string);
					}}
					valid={!nameError}
					value={quoteState.emergencyContactName || ""}
				/>
				{nameError ? <Error>Required</Error> : null}
			</div>
			<div className={"additional-details-value"}>
				<Label editorId={"emergencyContactPhone"}>
					Emergency Contact Phone{" "}
					{isRequired ? <span className={"required"}>&nbsp;*</span> : null}
				</Label>
				<MaskedTextBox
					id={"emergencyContactPhone"}
					mask={"(000) 000-0000"}
					onChange={(event: MaskedTextBoxChangeEvent) => {
						onClearFieldError?.("emergencyContactPhone");
						onChange("emergencyContactPhone", event.value as string);
					}}
					valid={!phoneError}
					value={quoteState.emergencyContactPhone || ""}
				/>
				{phoneError ? (
					<Error>Valid 10-digit phone number is required</Error>
				) : null}
			</div>
		</div>
	);
}
